import React, { useContext, useEffect, useState } from 'react';
import * as bodyScrollLock from 'body-scroll-lock';
import { AppContext } from '../../../Context/Context';
import { Link, useHistory } from 'react-router-dom';

const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;

export const Menu = () => {
    const [isPanelOpen, setIsPanelOpen] = useState(false);
    const [state, setState] = useContext(AppContext);
    const [activePath, setActivePath] = useState(window.location.pathname); // Track active-top path
    const [hasNotifications, setHasNotifications] = useState(false);
    const history = useHistory();

    let plan = null;

    useEffect(() => {
        const id = atob(sessionStorage.getItem('dtpln'));
        if (state.data !== null) {
            const planes = state.data.Usuario.Datos.Planes.Plan;
            plan = planes.filter((plan) => plan.Id === id)[0];

            if (plan && plan.Notificaciones && Array.isArray(plan.Notificaciones.Notificacion) && plan.Notificaciones.Notificacion.length > 0) {
                setHasNotifications(true);
            } else {
                setHasNotifications(false);
            }

            if (plan.EstadoPlan === 'Renunciado/Rescindido') {
                setState(prevState => ({ ...prevState, planRescindido: true }));
            }
        }
    }, [state.data, setState]);

    useEffect(() => {
        const unlisten = history.listen((location) => {
            setActivePath(location.pathname); // Update active-top path on route change
        });

        return () => unlisten(); // Clean up listener on component unmount
    }, [history]);

    const togglePanel = () => {
        setIsPanelOpen(!isPanelOpen);
        if (!isPanelOpen) {
            disableBodyScroll(document.body);
        } else {
            enableBodyScroll(document.body);
        }
    };

    const handleCerrarSesion = () => {
        sessionStorage.clear();
        enableBodyScroll(document.body);
        history.push('/');
    };

    return (
        <>
            <div className="menu-mobile">
                <div className="menu">
                    <div className="menu_mainDiv">
                        <p>MI PLAN</p>
                    </div>
                </div>
            </div>
            <div className="menu-desktop">
                <div className="menu">
                    <ul>
                        <li>
                            <p>MI PLAN</p>
                        </li>
                        <li className="topbar-link">
                            <Link to="/inicio" className={activePath === '/inicio' ? 'active-top' : ''}>Inicio</Link>
                        </li>
                        <li className="topbar-link">
                            <Link to="/instructivos" className={activePath === '/instructivos' ? 'active-top' : ''}>Instructivos</Link>
                        </li>
                        <li className="topbar-link">
                            <Link to="/notificaciones">
                                <div className="link-container">
                                    {/* Conditional rendering for the notification icon */}
                                    <img
                                        src={hasNotifications ? "/images/header/notificaciones.svg" : "/images/header/sin-notificaciones.svg"}
                                        alt="Notificaciones Icon"
                                    />
                                    <span className={activePath === '/notificaciones' ? 'active-top' : ''}>Notificaciones</span>
                                </div>
                            </Link>
                        </li>
                        <li className="topbar-link cerrar">
                            <a onClick={handleCerrarSesion} className="cerrar">Cerrar sesión</a>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
};
